<template>

  <div class=" block_row row col-12 no-gutters d-flex justify-content-center "  >
    <div class="col-12 col-md-3 d-flex justify-content-center">
      <img class="category-avatar-image" :src="image_url+category.image"  />
    </div>
    <div class="col-12 col-md-6  ">

      <h4 class="text-center vertical_center">{{ category.title }}</h4>
      <div class="text-center category_description vertical_center" v-html="category.description"  ></div>

    </div>

  </div>

</template>

<script>
import Vue from "vue";

export default {
  name: 'CategoryCard',
  props: {
    category:Object,

  },
  data(){
    return {
      'image_url':""
    };
  },
  mounted() {
    var app=this;
    app.image_url = Vue.config.IMAGE_URL;

  },
}
</script>

<style scoped>

</style>